<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      <v-row align="center" justify="start" class="mt-15">
        <v-col cols="12" sm="12" md="10" lg="8" xl="8">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Chat
      </div>
      <v-row align="center" justify="start" class="mt-15">
        <v-col cols="12" sm="12" md="10" lg="8" xl="8">
          <div class="text-h3 text-primary w-100 mb-3">
            Adicione abaixo o código do chat
          </div>
          <div>
            <v-textarea
              class="mb-5"
              hide-details
              rows="10"
              outlined
              :loading="salvando"
              :disabled="salvando"
              label="Código"
              v-model="form.coc_script_chat"
            ></v-textarea>
            <div class="text-right">
              <v-btn color="primary" @click="updateData()" :loading="salvando" :disabled="salvando" class="mb-4">Salvar</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      user: '',
      salvando: false,
      form: {
        coc_script_chat: '',
        uuid_coc_id: '',
        uuid_dis_id: ''
      }
    }
  },
  methods: {
    loadFunctions () {
      this.getDados()
    },
    async getDados () {
      this.user = JSON.parse(localStorage.getItem('user'))
      this.loading = true
      let dados = {
        uuid_dis_id: this.user.uuid_dis_id ? this.user.uuid_dis_id : this.user.uuid_usu_id
      }
      await Api.post('configuracao/chat', dados)
        .then(res => {
          this.form = res.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    updateData () {
      this.salvando = true
      Api.post('configuracao/chat/atualiza', this.form)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Dadoas atualizados com sucesso!',
            color: 'success'
          })
          setTimeout(() => location.reload(), 1350)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.mw-400 {
  max-width: 400px;
}
.ui-btn-inherit {
  margin-bottom: 3px!important;
  min-height: 10px!important;
}
.mw_img {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/ConfigChat.vue